import { COLLECTION_NAME, createCustomer } from '.';
import { setDocument } from 'db/mutations';
import { userDefault } from 'db/defaults';
import { matchReferrals } from './matchReferrals';

export const registerUser = async (userId, userData) => {
  if (!userId || !userData) {
    throw new Error('User ID and user data are required');
  }

  try {
    const referredBy = await matchReferrals(userId);

    if (referredBy) {
      userData.referredBy = referredBy;
    }

    const user = await setDocument(
      COLLECTION_NAME,
      userId,
      Object.assign({}, userDefault, userData)
    );

    await createCustomer(userId, userData);

    return user;
  } catch (error) {
    console.error('Error al registrar el usuario:', error);
    throw error;
  }
};
